import {
  SystemProps,
  Text,
  TextProps,
  ensurePlainTextFormat,
  ensureRichTextFormat,
} from "flicket-ui";
import { pick } from "@styled-system/props";

import { SlateRenderer } from "~components";

export function PlainTextRender({
  value,
  variant = "regular",
}: {
  value: string;
  variant?: TextProps["variant"];
}) {
  return (
    <Text variant={variant} whiteSpace="pre-line">
      {ensurePlainTextFormat(value)}
    </Text>
  );
}

export function RichTextRender({ value }: { value: string }) {
  return (
    <SlateRenderer type="experienceSales" value={ensureRichTextFormat(value)} />
  );
}

/**
 * Accepts a string as plaing or rich text and returns a preview of the text with a "more info" link.
 *
 * Both plain text and rich text is squashed into plain text without line breaks.
 *
 */
export function TextPreviewRender({
  value,
  lines = 3,
  variant = "regular",
  showMoreInfo = true,
  ...props
}: {
  value: string;
  lines?: number;
  showMoreInfo?: boolean;
  variant?: "regular" | "small";
} & SystemProps) {
  const text = ensurePlainTextFormat(value);

  if (text?.length === 0) return null;

  return (
    <>
      <Text
        variant={variant}
        {...pick(props)}
        css={`
          -webkit-box-orient: vertical;
          display: -webkit-box;
          -webkit-line-clamp: ${lines};
          overflow: hidden;
        `}
      >
        {text}
      </Text>
      {showMoreInfo && (
        <Text variant="small" textDecoration="underline" mt="1/2">
          More info
        </Text>
      )}
    </>
  );
}
